import styled, {
  css,
  DefaultTheme,
  ThemedCssFunction,
} from 'styled-components';
import { media } from 'src/components/base';
import { FC, cloneElement, ReactNode, isValidElement } from 'react';

type Props = { children: ReactNode; className?: string };

const hideInViewports = (viewports: ThemedCssFunction<DefaultTheme>[]) => (
  Component: FC<Props>
) => styled(Component)`
  && {
    ${viewports.map(
      viewport => css`
        ${viewport` display: none;`}
      `
    )}
  }
`;

const applyStyles = ({ children: child, className }: Props) => {
  if (!isValidElement(child)) {
    return null;
  }

  return cloneElement(child, { className } as any);
};

/**
 * These components apply a className to their given child in order to hide it in certain viewports.
 * For them to work, they can only be given a single child that takes a `className` prop that then passes it
 * to its inner-most HTML element. If you want to give them multiple children, or if it's not suitable to
 * pass along `className` all the way down, wrap the childen in an HTML element (e.g. a `div`).
 */
export const DesktopOnly = hideInViewports([media.mediumDown])(applyStyles);
export const TabletOnly = hideInViewports([media.smallOnly, media.largeUp])(
  applyStyles
);
export const MobileAndDesktopOnly = hideInViewports([media.mediumOnly])(
  applyStyles
);
export const MobileOnly = hideInViewports([media.mediumUp])(applyStyles);
export const MediumDown = hideInViewports([media.largeUp])(applyStyles);
export const MediumUp = hideInViewports([media.smallOnly])(applyStyles);
